import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography,
} from "@mui/material";
import AllocationManager from "./AllocationManager";
import { useMe } from "../MeContext";
import { useFullScreenDialog } from "../useFullScreenDialog";

/**
 * Everything allocated on one event — every item, to everyone. The other three
 * views of allocations sit inside a record they belong to (an item, a person, one
 * person's attendance); this is the one that answers "what has gone out for this
 * event, and is any of it still out?", so it is the one that lets the reader choose
 * the order, narrow by status, and print or download the result.
 *
 * The list itself is the shared AllocationManager, fixed to this event: it drops
 * the Event column and narrows the person picker to the event's own people.
 *
 * Props:
 *  - event:   the event record ({id, label_long, …}); null when closed
 *  - open:    boolean
 *  - onClose: () => void
 */
export default function EventAllocationsDialog({ event, open, onClose }) {
  const { can } = useMe();
  const fullScreen = useFullScreenDialog();
  // `event` is kept by the caller while the dialog fades out, so this stays a
  // number until it has gone.
  const eventId = event?.id;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={fullScreen}>
      <DialogTitle>Allocations — {event?.label_long || "event"}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          <Typography variant="caption" color="text.secondary">
            Kit issued to people for this event. Rows save as you go — there is
            nothing here to Save.
          </Typography>
          <AllocationManager
            eventId={open ? eventId : null}
            showStatusFilter
            showSort
            exportTitle={event?.label_long}
            showReturn
            canAdd={can("InventoryItems.add")}
            canEdit={can("InventoryItems.edit")}
            canDelete={can("InventoryItems.delete")}
            canExport={can("InventoryItems.export")} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
